
/**
 * Local storage composable
 */
export function useLocalStorage() {

  //Get item from local storage
  const getFromLocalStorage = (key, defaultValue) => {
    try {
      const raw = localStorage.getItem(key)
      if (raw === null) {
        return defaultValue
      }
      if (raw.startsWith('{') || raw.startsWith('[') || raw.startsWith('"')) {
        return JSON.parse(raw)
      }
      if (typeof raw === 'string' && raw.match(/^-?\d+$/)) {
        return parseInt(raw)
      }
      if (raw === 'true') {
        return true
      }
      if (raw === 'false') {
        return false
      }
      return raw
    }
    catch {
      return defaultValue
    }
  }

  //Set item in local storage
  const setInLocalStorage = (key, value) => {
    try {
      const raw = JSON.stringify(value)
      localStorage.setItem(key, raw)
    }
    catch {
      //Fall through
    }
  }

  //Remove item from local storage
  const removeFromLocalStorage = (key) => {
    try {
      localStorage.removeItem(key)
    }
    catch {
      //Fall through
    }
  }

  //Return interface
  return {
    getFromLocalStorage,
    setInLocalStorage,
    removeFromLocalStorage,
  }
}
